const e = {
  xs: 0,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
}, s = Object.keys(e), t = Object.values(e);
export {
  s as BreakpointNames,
  e as BreakpointSizes,
  t as BreakpointValues
};
//# sourceMappingURL=index.ts.js.map
